module.exports = __webpack_public_path__ + "img/fig12.474ec865.jpg";